import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigService} from '../spyglass-search/config.service';

@Component({
    selector: 'app-pre-chat',
    standalone: false,
    templateUrl: './pre-chat.component.html',
    styleUrls: ['./pre-chat.component.scss']
})
export class PreChatComponent implements OnInit {

    swirlDocOrigin: string = '';
    docsChatCookieSamesite: string = '';
    docsChatCookieSecure: string = '';

    private readonly LOG_PREFIX = '[IFRAME]';

    constructor(private router: Router, private configService: ConfigService) {}

    private nowTs(): string {
        return new Date().toISOString();
    }

    // Small helper to avoid logging raw token values
    private redactPayload(payload: any): any {
        try {
            const clone = JSON.parse(JSON.stringify(payload));
            if (clone?.['swirl-token']) clone['swirl-token'] = '[REDACTED]';
            if (clone?.['csrftoken'])   clone['csrftoken']   = '[REDACTED]';
            return clone;
        } catch { return '[unserializable]'; }
    }

    ngOnInit(): void {
        console.log(this.LOG_PREFIX, this.nowTs(), 'script start');
        window.addEventListener(
            'message',
            (e: MessageEvent) => {
                console.log(this.LOG_PREFIX, this.nowTs(), 'message seen from', e.origin, this.redactPayload(e.data));
                console.log(this.LOG_PREFIX, this.nowTs(), 'swirlDocOrigin at time of message?', this.swirlDocOrigin);
                this.handleMessage(e);
            }
        );
        console.log(this.LOG_PREFIX, this.nowTs(), 'listener attached');

        this.configService.getConfig('default').subscribe(configResponse => {
            if (configResponse) {
                console.log(this.LOG_PREFIX, this.nowTs(), 'Applying config response:', configResponse);
                if (configResponse.swirlDocOrigin) {
                    this.swirlDocOrigin = configResponse.swirlDocOrigin;
                }
                if (configResponse.docsChatCookieSamesite) {
                    this.docsChatCookieSamesite = configResponse.docsChatCookieSamesite;
                }
                if (configResponse.docsChatCookieSecure) {
                    this.docsChatCookieSecure = configResponse.docsChatCookieSecure;
                }
            }
        });
    }

    private handleMessage(event: MessageEvent): void {
        console.log(this.LOG_PREFIX, this.nowTs(), 'Received message from origin:', event.origin, 'data:', this.redactPayload(event.data));

        if (event.origin !== this.swirlDocOrigin) {
            console.warn(this.LOG_PREFIX, this.nowTs(), 'Ignored message from untrusted origin:', event.origin);
            return;
        }

        if (event.data && event.data.action === 'setLocalStorage') {
            console.log(this.LOG_PREFIX, this.nowTs(), 'Setting local storage values');
            const payload = event.data.payload;
            // capture nonce from host
            const nonce = event.data.nonce;

            if (payload && typeof payload === 'object') {
                const allowed = new Set(['swirl-token', 'swirl-chat-status', 'swirl-rag-rating-status', 'csrftoken']);
                for (const [key, value] of Object.entries(payload)) {
                    if (!allowed.has(key)) {
                        console.warn(this.LOG_PREFIX, this.nowTs(), 'Ignoring unexpected key:', key);
                        continue;
                    }
                    if (key != 'csrftoken') {
                        localStorage.setItem(key, String(value));
                        console.log(this.LOG_PREFIX, this.nowTs(), `Set localStorage item: ${key}`);
                    }
                }

                // Check if a csrftoken is present and set it as a cookie
                if (payload.hasOwnProperty('csrftoken')) {
                    // Set the cookie for the current domain (the iframe's domain)
                    document.cookie = `csrftoken=${encodeURIComponent(payload.csrftoken)};
                    Domain=None;
                    SameSite=${this.docsChatCookieSamesite};
                    Secure=${this.docsChatCookieSecure}`;
                    console.log(this.LOG_PREFIX, this.nowTs(), `Set csrftoken cookie for ${this.swirlDocOrigin}`);
                }

                console.log(this.LOG_PREFIX, this.nowTs(), 'Local storage successfully updated');
                window.parent.postMessage({ action: 'setLocalStorage-ack', nonce }, this.swirlDocOrigin);
                // After setting localStorage and cookie, navigate to the chat page
                this.hardNavigate('/swirl/chat-throttle/');
            } else {
                console.error(this.LOG_PREFIX, this.nowTs(), 'Payload is missing or not an object:', payload);
            }
        } else {
            console.warn(this.LOG_PREFIX, this.nowTs(), 'Unknown action received:', event.data && event.data.action);
        }
    }

    private hardNavigate(url: string): void {
        console.log(this.LOG_PREFIX, this.nowTs(), 'Hard navigating to', url);
        window.location.assign(url);
    }
}
